$(document).ready(function(){  
  
  $('.homeslider').bxSlider({
  auto: true,
  speed: 5000,
    pause: 5000,
    touchEnabled: false
  });

//   $( ".clicko .on_slide_img img" ).click(function() {
//        var testclick = $(this).attr('data-id');
//      //alert(testclick);
//      // $(this).parent().show();
//     $('.collection_slide_pp').hide();
//      $('#collection_slide_pp_'+ testclick).fadeToggle( "fast", "linear" ); 
//     //$('.product-list-holder #collection_slide_pp').css('display','none'); 
//      //$(this).next().next().next().next().css('display','block'); 
//     //collection_slide_pp_{{ product.id }}
// });
  
  $( ".close_coll_pp" ).click(function() {
    var closepanl = $(this).attr('data-id');
    //alert('test');
    $('#collection_slide_pp_' + closepanl).hide();  
}); 
  
  
   $( ".collection_product_tabs_spp li.aboutnv" ).on('click',function(){
       var aboutnvclick = $(this).attr('data-id');
    $('.collection_product_tabs_spp li').removeClass('active');
    $(this).addClass('active');
    $('#tab-1-' + aboutnvclick).show();
	$('#tab-2-' + aboutnvclick).hide();
	$('#tab-3-' + aboutnvclick).hide();
     
});


 $( ".collection_product_tabs_spp li.nutrinv" ).on('click',function(){
       var nutrinvclick = $(this).attr('data-id');
   $('.collection_product_tabs_spp li').removeClass('active');
    $(this).addClass('active');
    $('#tab-1-' + nutrinvclick).hide();
	$('#tab-2-' + nutrinvclick).show();
	$('#tab-3-' + nutrinvclick).hide();
     
});


 $( ".collection_product_tabs_spp li.reviewnv" ).on('click',function(){
       var reviewnvclick = $(this).attr('data-id');
  $('.collection_product_tabs_spp li').removeClass('active');
   $(this).addClass('active');
     
    $('#tab-1-' + reviewnvclick).hide();
	$('#tab-2-' + reviewnvclick).hide();
	$('#tab-3-' + reviewnvclick).show();
     
});
  
  

 $(".feat-home-prods select").change(function() {
     var selop= $("option:selected", $(this)).val();
     $('.feat-home-prods').find("#cartadd").val(selop);
}); 
  
  
   $('.qtybox .btnqty').on('click', function(){
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
            qty++;
          }else {
            if(qty > 1) {
              qty--;
            }
          }
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
        }); 
  
 
  
  $("#home_fbox").children().each(function(i) {
  $(this).addClass("item_slide_pp_" + (i+1));
});
  

   $( ".item_slide_pp_1 .img_feat_pp" ).click(function() { 
       $('.item_slide_pp_1 .desk_cut').hide();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
      $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
      $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_1 #slide_product_area_section').fadeToggle( "fast", "linear" );
      $('.item_slide_pp_1 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_2 .img_feat_pp" ).click(function() {
        $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').hide();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_2 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_2 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_2 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_3 .img_feat_pp" ).click(function() {
       $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').hide();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_3 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_3 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_4 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').hide();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
    $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
         $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_4 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_4 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_5 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').hide();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
       $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_5 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_5 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_6 .img_feat_pp" ).click(function() {
      $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').hide();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_6 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_6 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_7 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').hide();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_7 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_7 .desk_cut').fadeToggle( "fast", "linear" );
});
  
  $( ".item_slide_pp_8 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').hide();
      $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
       $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_8 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_8 .desk_cut').fadeToggle( "fast", "linear" );
});   
  
  
   $( ".item_slide_pp_9 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();  
      $('.item_slide_pp_9 .desk_cut').hide();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
        $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_9 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_9 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_9 .desk_cut').fadeToggle( "fast", "linear" );
});   
  
  $( ".item_slide_pp_10 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();  
      $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').hide();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
        $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
      $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_10 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_10 .desk_cut').fadeToggle( "fast", "linear" );
});   
  
  
  $( ".item_slide_pp_11 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show(); 
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').hide();
      $('.item_slide_pp_12 .desk_cut').show();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_11 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_11 .desk_cut').fadeToggle( "fast", "linear" );
});   
  
  
  $( ".item_slide_pp_12 .img_feat_pp" ).click(function() {
     $('.item_slide_pp_1 .desk_cut').show();
     $('.item_slide_pp_2 .desk_cut').show();
     $('.item_slide_pp_3 .desk_cut').show();
     $('.item_slide_pp_4 .desk_cut').show();
     $('.item_slide_pp_5 .desk_cut').show();
     $('.item_slide_pp_6 .desk_cut').show();
     $('.item_slide_pp_7 .desk_cut').show();
     $('.item_slide_pp_8 .desk_cut').show();
     $('.item_slide_pp_9 .desk_cut').show();
      $('.item_slide_pp_10 .desk_cut').show();
      $('.item_slide_pp_11 .desk_cut').show();
      $('.item_slide_pp_12 .desk_cut').hide();
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
        $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
      $('.item_slide_pp_12 .arrow_up_slide_ind').fadeToggle( "fast", "linear" );
     $('.item_slide_pp_12 #slide_product_area_section').fadeToggle( "fast", "linear" );
    $('.item_slide_pp_12 .desk_cut').fadeToggle( "fast", "linear" );
});   
  
  
  

 
  
   $('body.templateIndex .item_slide_pp_1 .close_pp').click(function() {
      $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_1 #slide_product_area_section').hide();
     $('.item_slide_pp_1 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_2 .close_pp').click(function() {
      $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_2 #slide_product_area_section').hide();
     $('.item_slide_pp_2 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_3 .close_pp').click(function() {
      $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_3 #slide_product_area_section').hide();
     $('.item_slide_pp_3 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_4 .close_pp').click(function() {
      $('.item_slide_pp_4 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_4 #slide_product_area_section').hide();
     $('.item_slide_pp_4 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_5 .close_pp').click(function() {
      $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_5 #slide_product_area_section').hide();
     $('.item_slide_pp_5 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_6 .close_pp').click(function() {
      $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_6 #slide_product_area_section').hide();
     $('.item_slide_pp_6 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_7 .close_pp').click(function() {
      $('.item_slide_pp_7 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_7 #slide_product_area_section').hide();
     $('.item_slide_pp_7 .desk_cut').show();
});
  
   $('body.templateIndex .item_slide_pp_8 .close_pp').click(function() {
      $('.item_slide_pp_8 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_8 #slide_product_area_section').hide();
     $('.item_slide_pp_8 .desk_cut').show();
});
  
  $('body.templateIndex .item_slide_pp_9 .close_pp').click(function() {
      $('.item_slide_pp_9 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_9 #slide_product_area_section').hide();
     $('.item_slide_pp_9 .desk_cut').show();
});
  
  $('body.templateIndex .item_slide_pp_10 .close_pp').click(function() {
      $('.item_slide_pp_10 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_10 #slide_product_area_section').hide();
     $('.item_slide_pp_10 .desk_cut').show();
});
  
  $('body.templateIndex .item_slide_pp_11 .close_pp').click(function() {
      $('.item_slide_pp_11 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_11 #slide_product_area_section').hide();
     $('.item_slide_pp_11 .desk_cut').show();
});
  
  $('body.templateIndex .item_slide_pp_12 .close_pp').click(function() {
      $('.item_slide_pp_12 .arrow_up_slide_ind').hide();
     $('.item_slide_pp_12 #slide_product_area_section').hide();
     $('.item_slide_pp_12 .desk_cut').show();
});
  
  
  
  
  $('.dietary_option_nv_link').click(function() {
    $('.collect_front_menu_nav2').hide();
  $('.collect_front_menu_nav').slideToggle();
});
  
  $('.dietary_option_nv_link2').click(function() {
     $('.collect_front_menu_nav').hide();
  $('.collect_front_menu_nav2').slideToggle();
});
  
  
  $('.item_slide_pp_1 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_1 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_1 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_1 .slide_pp_tabs_area #tab-2').show();
   $('.item_slide_pp_1 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_1 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_1 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_1 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_1 .slide_pp_tabs_area #tab-1').show();
      $('.item_slide_pp_1 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_1 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_1 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_1 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_1 .slide_pp_tabs_area #tab-3').show();
      $('.item_slide_pp_1 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  $('.item_slide_pp_2 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_2 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_2 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_2 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_2 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_2 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_2 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_2 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_2 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_2 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_2 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_2 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_2 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_2 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_2 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_3 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_3 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_3 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_3 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_3 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_3 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_3 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_3 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_3 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_3 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_3 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_3 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_3 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_3 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_3 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_4 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_4 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_4 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_4 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_4 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_4 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_4 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_4 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_4 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_4 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_4 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_4 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_4 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_4 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_4 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_5 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_5 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_5 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_5 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_5 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_5 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_5 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_5 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_5 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_5 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_5 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_5 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_5 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_5 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_5 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_6 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_6 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_6 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_6 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_6 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_6 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_6 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_6 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_6 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_6 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_6 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_6 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_6 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_6 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_6 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_7 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_7 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_7 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_7 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_7 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_7 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_7 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_7 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_7 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_7 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_7 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_7 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_7 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_7 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_7 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  $('.item_slide_pp_8 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_8 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_8 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_8 .slide_pp_tabs_area #tab-2').show();
    $('.item_slide_pp_8 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_8 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_8 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_8 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_8 .slide_pp_tabs_area #tab-1').show();
     $('.item_slide_pp_8 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_8 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_8 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_8 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_8 .slide_pp_tabs_area #tab-3').show();
     $('.item_slide_pp_8 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  
  $('.item_slide_pp_9 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_9 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_9 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_9 .slide_pp_tabs_area #tab-2').show();
   $('.item_slide_pp_9 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_9 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_9 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_9 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_9 .slide_pp_tabs_area #tab-1').show();
      $('.item_slide_pp_9 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_9 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_9 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_9 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_9 .slide_pp_tabs_area #tab-3').show();
      $('.item_slide_pp_9 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  $('.item_slide_pp_10 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_10 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_10 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_10 .slide_pp_tabs_area #tab-2').show();
   $('.item_slide_pp_10 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_10 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_10 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_10 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_10 .slide_pp_tabs_area #tab-1').show();
      $('.item_slide_pp_10 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_10 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_10 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_10 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_10 .slide_pp_tabs_area #tab-3').show();
      $('.item_slide_pp_10 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  $('.item_slide_pp_11 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_11 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_11 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_11 .slide_pp_tabs_area #tab-2').show();
   $('.item_slide_pp_11 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_11 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_11 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_11 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_11 .slide_pp_tabs_area #tab-1').show();
      $('.item_slide_pp_11 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_11 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_11 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_11 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_11 .slide_pp_tabs_area #tab-3').show();
      $('.item_slide_pp_11 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  $('.item_slide_pp_12 .home_product_tabs li:nth-child(2)').click(function() {
   $('.item_slide_pp_12 .slide_pp_tabs_area #tab-1').hide();
    $('.item_slide_pp_12 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_12 .slide_pp_tabs_area #tab-2').show();
   $('.item_slide_pp_12 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_12 .home_product_tabs li:nth-child(1)').click(function() {
   $('.item_slide_pp_12 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_12 .slide_pp_tabs_area #tab-3').hide();
  $('.item_slide_pp_12 .slide_pp_tabs_area #tab-1').show();
      $('.item_slide_pp_12 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
   $('.item_slide_pp_12 .home_product_tabs li:nth-child(3)').click(function() {
   $('.item_slide_pp_12 .slide_pp_tabs_area #tab-2').hide();
    $('.item_slide_pp_12 .slide_pp_tabs_area #tab-1').hide();
  $('.item_slide_pp_12 .slide_pp_tabs_area #tab-3').show();
      $('.item_slide_pp_12 .slide_pp_tabs_area h4').removeClass('active'); 
     $(this).find('h4').addClass('active'); 
});
  
  
  
  
  
  
  
  $('#slide a').click(function() {
      var link_colr= $(this).attr('href');
	  if ( link_colr == "#home-product-cyan") {               
               $('.item_slide_pp_1 .arrow_up_slide_ind').show();
               $('.item_slide_pp_1 #slide_product_area_section').show();
               $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_2 #slide_product_area_section').hide();
               $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_5 #slide_product_area_section').hide();
        	   $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_3 #slide_product_area_section').hide();
               $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_6 #slide_product_area_section').hide(); 
                  $('.item_slide_pp_1 .desk_cut').show();
                  $('.item_slide_pp_2 .desk_cut').show();
                  $('.item_slide_pp_5 .desk_cut').show();
                  $('.item_slide_pp_3 .desk_cut').show();
                  $('.item_slide_pp_6 .desk_cut').show();
                  
                $('html, body').animate({scrollTop: $(this).offset().top + 800}, 10);
	 } else if ( link_colr == "#home-product-orange") {
               $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_1 #slide_product_area_section').hide();
               $('.item_slide_pp_2 .arrow_up_slide_ind').show();
               $('.item_slide_pp_2 #slide_product_area_section').show();
               $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_5 #slide_product_area_section').hide();
        	   $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_3 #slide_product_area_section').hide();
               $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_6 #slide_product_area_section').hide();
                 $('.item_slide_pp_1 .desk_cut').show();
                  $('.item_slide_pp_2 .desk_cut').show();
                  $('.item_slide_pp_5 .desk_cut').show();
                  $('.item_slide_pp_3 .desk_cut').show();
                  $('.item_slide_pp_6 .desk_cut').show();
               $('html, body').animate({scrollTop: $(this).offset().top + 800}, 10);
	 } else if ( link_colr == "#home-product-green") {
               $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_1 #slide_product_area_section').hide();
               $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_2 #slide_product_area_section').hide();
               $('.item_slide_pp_5 .arrow_up_slide_ind').show();
               $('.item_slide_pp_5 #slide_product_area_section').show();
        	   $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_3 #slide_product_area_section').hide();
               $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_6 #slide_product_area_section').hide();
                $('.item_slide_pp_1 .desk_cut').show();
                  $('.item_slide_pp_2 .desk_cut').show();
                  $('.item_slide_pp_5 .desk_cut').show();
                  $('.item_slide_pp_3 .desk_cut').show();
                  $('.item_slide_pp_6 .desk_cut').show();
               $('html, body').animate({scrollTop: $(this).offset().top + 800}, 10);
	 } else if ( link_colr == "#home-product-red") {
               $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_1 #slide_product_area_section').hide();
               $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_2 #slide_product_area_section').hide();
               $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_5 #slide_product_area_section').hide();
        	   $('.item_slide_pp_3 .arrow_up_slide_ind').show();
               $('.item_slide_pp_3 #slide_product_area_section').show();
               $('.item_slide_pp_6 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_6 #slide_product_area_section').hide();
                 $('.item_slide_pp_1 .desk_cut').show();
                  $('.item_slide_pp_2 .desk_cut').show();
                  $('.item_slide_pp_5 .desk_cut').show();
                  $('.item_slide_pp_3 .desk_cut').show();
                  $('.item_slide_pp_6 .desk_cut').show();
               $('html, body').animate({scrollTop: $(this).offset().top + 800}, 10);
	 } else if ( link_colr == "#home-product-blue") {
               $('.item_slide_pp_1 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_1 #slide_product_area_section').hide();
               $('.item_slide_pp_2 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_2 #slide_product_area_section').hide();
               $('.item_slide_pp_5 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_5 #slide_product_area_section').hide();
        	   $('.item_slide_pp_3 .arrow_up_slide_ind').hide();
               $('.item_slide_pp_3 #slide_product_area_section').hide();
               $('.item_slide_pp_6 .arrow_up_slide_ind').show();
               $('.item_slide_pp_6 #slide_product_area_section').show();
                $('.item_slide_pp_1 .desk_cut').show();
                  $('.item_slide_pp_2 .desk_cut').show();
                  $('.item_slide_pp_5 .desk_cut').show();
                  $('.item_slide_pp_3 .desk_cut').show();
                  $('.item_slide_pp_6 .desk_cut').show();
               $('html, body').animate({scrollTop: $(this).offset().top + 800}, 10);
	 } else {
	 }
}); 
  

  
 
$(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});
  
  
document.addEventListener('touchmove', function(e) {e.preventDefault();}, true);
  
jQuery(document).ready(function() {
	
  // if($(window).width() <= 1024){     
  //   /*-- Scroll Up/Down add class --*/
  //   var lastScrollTop = 0;
      
  //   $(window).scroll(function(event){
  //     console.log("<=1024");
      
  //      var st = $(window).scrollTop();
  //      if (st > lastScrollTop){
  //          //âíèç
  //   	   $('body').removeClass('unreal-sticky-header');
  //   	   $('body').removeClass('unreal-sticky-header-on');
  //      } else if (st == 0) {
  //         // ââåðõ 
  //   	   $('body').removeClass('unreal-sticky-header-on');
  //   	   $('body').removeClass('unreal-sticky-header');
  //      } else {
  //         // ââåðõ 
  //   	   $('body').addClass('unreal-sticky-header-on');
  //   	   $('body').removeClass('unreal-sticky-header');
  //      }
  //      lastScrollTop = st;
  //   });	
  // }  
  
  
// if($(window).width() > 1024){     
  /*-- Scroll Up/Down add class --*/
var lastScrollTop = 0;
var desktopHeaderHeight = 10;
  
$(window).scroll(function(event){
  
   var st = $(window).scrollTop();
   if (st > lastScrollTop && st > desktopHeaderHeight){
       //âíèç
	   $('body').addClass('unreal-sticky-header');
	   $('body').removeClass('unreal-sticky-header-on');
   } else if (st == 0 || st <= desktopHeaderHeight) {
      // ââåðõ 
	   $('body').removeClass('unreal-sticky-header-on');
	   $('body').removeClass('unreal-sticky-header');
   } else {
      // ââåðõ 
	   $('body').addClass('unreal-sticky-header-on');
	   $('body').removeClass('unreal-sticky-header');
   }
   lastScrollTop = st;
});	
// }   
  
  
  /* reviews slider */
  
  $('.Reviews-slider').slick({
    slidesToShow: 1,
    dots:false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  });
  
});  
  
  
$('.close_mobile_nv').click(function() {
   $('#mobile_menu_full_nav_unreal').hide();  
});


$('.mobile-nav').click(function() {
   $('#mobile_menu_full_nav_unreal').show();  
});  
  
  

  
  $( '.nav-tabs-unreal .tab2' ).click(function() {
    $('.nav-tabs-unreal .li').removeClass('active');
	$('.nav-tabs-unreal .tab2').addClass('active');
	 $('#unreal_product_tabs .tab_prod').removeClass('active');
    $('#unreal_product_tabs .tab_prod').hide();
	$('#unreal_product_tabs #tab-2').addClass('active');
    $('#unreal_product_tabs #tab-2').show();
});
  
  $( '.nav-tabs-unreal .tab1' ).click(function() {
    $('.nav-tabs-unreal .li').removeClass('active');
	$('.nav-tabs-unreal .tab1').addClass('active');
	 $('#unreal_product_tabs .tab_prod').removeClass('active');
    $('#unreal_product_tabs .tab_prod').hide();
	$('#unreal_product_tabs #tab-1').addClass('active');
    $('#unreal_product_tabs #tab-1').show();
});


$( '.nav-tabs-unreal .tab3' ).click(function() {
    $('.nav-tabs-unreal .li').removeClass('active');
	$('.nav-tabs-unreal .tab3').addClass('active');
	 $('#unreal_product_tabs .tab_prod').removeClass('active');
    $('#unreal_product_tabs .tab_prod').hide();
	$('#unreal_product_tabs #tab-3').addClass('active');
    $('#unreal_product_tabs #tab-3').show();
});
  
  
  
  $('.nav-tabs-unreal-mobile .tab2').click(function() {
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .tab_prod').hide(); 
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .fa').removeClass('fa-chevron-up'); 
   $('.nav-tabs-unreal-mobile .li.tab1 .fa').addClass('fa-chevron-down'); 
    $('.nav-tabs-unreal-mobile .li.tab3 .fa').addClass('fa-chevron-down'); 
       $('.nav-tabs-unreal-mobile .li.tab2 .fa').removeClass('fa-chevron-down'); 
   $('.nav-tabs-unreal-mobile .li.tab2 .fa').addClass('fa-chevron-up');   
   $('.nav-tabs-unreal-mobile #tab-2').addClass('active'); 
   $('.nav-tabs-unreal-mobile #tab-2').show(); 
});
  
  
  $('.nav-tabs-unreal-mobile .tab1').click(function() {
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .tab_prod').hide(); 
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .fa').removeClass('fa-chevron-up'); 
   $('.nav-tabs-unreal-mobile .li.tab3 .fa').addClass('fa-chevron-down'); 
    $('.nav-tabs-unreal-mobile .li.tab2 .fa').addClass('fa-chevron-down'); 
       $('.nav-tabs-unreal-mobile .li.tab1 .fa').removeClass('fa-chevron-down'); 
   $('.nav-tabs-unreal-mobile .li.tab1 .fa').addClass('fa-chevron-up');   
   $('.nav-tabs-unreal-mobile #tab-1').addClass('active'); 
   $('.nav-tabs-unreal-mobile #tab-1').show(); 
});


$('.nav-tabs-unreal-mobile .tab3').click(function() {
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .tab_prod').hide(); 
   $('.nav-tabs-unreal-mobile .tab_prod').removeClass('active'); 
   $('.nav-tabs-unreal-mobile .fa').removeClass('fa-chevron-up'); 
   $('.nav-tabs-unreal-mobile .li.tab1 .fa').addClass('fa-chevron-down'); 
    $('.nav-tabs-unreal-mobile .li.tab2 .fa').addClass('fa-chevron-down'); 
     $('.nav-tabs-unreal-mobile .li.tab3 .fa').removeClass('fa-chevron-down'); 
   $('.nav-tabs-unreal-mobile .li.tab3 .fa').addClass('fa-chevron-up');   
   $('.nav-tabs-unreal-mobile #tab-3').addClass('active'); 
   $('.nav-tabs-unreal-mobile #tab-3').show(); 
});
  
  

  
    
  
$('.item_slide_pp_1 #product-select').on('change', function() {
    var selval1= $(this).val();
	$('.item_slide_pp_1 .bold-ro__product').addClass('bold-ro__product-id-'+ selval1);	
});

$('.item_slide_pp_2 #product-select').on('change', function() {
    var selval2= $(this).val();
	$('.item_slide_pp_2 .bold-ro__product').addClass('bold-ro__product-id-'+ selval2);	
});


$('.item_slide_pp_3 #product-select').on('change', function() {
    var selval3= $(this).val();
	$('.item_slide_pp_3 .bold-ro__product').addClass('bold-ro__product-id-'+ selval3);	
});

$('.item_slide_pp_4 #product-select').on('change', function() {
    var selval4= $(this).val();
	$('.item_slide_pp_4 .bold-ro__product').addClass('bold-ro__product-id-'+ selval4);	
});


$('.item_slide_pp_5 #product-select').on('change', function() {
    var selval5= $(this).val();
	$('.item_slide_pp_5 .bold-ro__product').addClass('bold-ro__product-id-'+ selval5);	
});


$('.item_slide_pp_6 #product-select').on('change', function() {
    var selval6= $(this).val();
	$('.item_slide_pp_6 .bold-ro__product').addClass('bold-ro__product-id-'+ selval6);	
});


$('.item_slide_pp_7 #product-select').on('change', function() {
    var selval7= $(this).val();
	$('.item_slide_pp_7 .bold-ro__product').addClass('bold-ro__product-id-'+ selval7);	
});


$('.item_slide_pp_8 #product-select').on('change', function() {
    var selval8= $(this).val();
	$('.item_slide_pp_8 .bold-ro__product').addClass('bold-ro__product-id-'+ selval8);	
}); 
 
  

  
  
 
$('.item_slide_pp_1 .bold-ro__order-interval').on('change', function() {
    var selorderval1= $(this).val();
	if (selorderval1 == 1) {
	$('.item_slide_pp_1 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval1 == 2) {
	$('.item_slide_pp_1 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval1 == 3) {
	$('.item_slide_pp_1 .bold-ro__frequency-type-text').val("Month(s)");
	}
});  
  

$('.item_slide_pp_2 .bold-ro__order-interval').on('change', function() {
    var selorderval2= $(this).val();
	if (selorderval2 == 1) {
	$('.item_slide_pp_2 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval2 == 2) {
	$('.item_slide_pp_2 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval2 == 3) {
	$('.item_slide_pp_2 .bold-ro__frequency-type-text').val("Month(s)");
	}
});  
  
  
  
$('.item_slide_pp_3 .bold-ro__order-interval').on('change', function() {
    var selorderval3= $(this).val();
	if (selorderval3 == 1) {
	$('.item_slide_pp_3 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval3 == 2) {
	$('.item_slide_pp_3 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval3 == 3) {
	$('.item_slide_pp_3 .bold-ro__frequency-type-text').val("Month(s)");
	}
});
  
  
$('.item_slide_pp_4 .bold-ro__order-interval').on('change', function() {
    var selorderval4= $(this).val();
	if (selorderval4 == 1) {
	$('.item_slide_pp_4 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval4 == 2) {
	$('.item_slide_pp_4 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval4 == 3) {
	$('.item_slide_pp_4 .bold-ro__frequency-type-text').val("Month(s)");
	}
});
  
  
$('.item_slide_pp_5 .bold-ro__order-interval').on('change', function() {
    var selorderval5= $(this).val();
	if (selorderval5 == 1) {
	$('.item_slide_pp_5 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval5 == 2) {
	$('.item_slide_pp_5 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval5 == 3) {
	$('.item_slide_pp_5 .bold-ro__frequency-type-text').val("Month(s)");
	}
});
  
  
$('.item_slide_pp_6 .bold-ro__order-interval').on('change', function() {
    var selorderval6= $(this).val();
	if (selorderval6 == 1) {
	$('.item_slide_pp_6 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval6 == 2) {
	$('.item_slide_pp_6 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval6 == 3) {
	$('.item_slide_pp_6 .bold-ro__frequency-type-text').val("Month(s)");
	}
});
  
  
  
$('.item_slide_pp_7 .bold-ro__order-interval').on('change', function() {
    var selorderval7= $(this).val();
	if (selorderval7 == 1) {
	$('.item_slide_pp_7 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval7 == 2) {
	$('.item_slide_pp_7 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval7 == 3) {
	$('.item_slide_pp_7 .bold-ro__frequency-type-text').val("Month(s)");
	}
});
  
  
  
$('.item_slide_pp_8 .bold-ro__order-interval').on('change', function() {
    var selorderval8= $(this).val();
	if (selorderval8 == 1) {
	$('.item_slide_pp_8 .bold-ro__frequency-type-text').val("Day(s)");
	} else if (selorderval8 == 2) {
	$('.item_slide_pp_8 .bold-ro__frequency-type-text').val("Week(s)");
	} else if (selorderval8 == 3) {
	$('.item_slide_pp_8 .bold-ro__frequency-type-text').val("Month(s)");
	}
});  
  
  

  
 $( "#home_fbox .bold-ro__one-time-div .bold-ro__recurring-lbl" ).click(function() {
  $('.slide_product_pp .bold-ro__order-interval-container').hide();
   $('#home_fbox .bold-ro__one-time-radio-btn').prop("checked",true);
    $('#home_fbox .bold-ro__subscribe-radio-btn').removeAttr('checked');
    $('#home_fbox  .bold-ro__one-time-div').addClass('bold-ro__bold-active');
   $('#home_fbox  .bold-ro__recurring-div').removeClass('bold-ro__bold-active');
   $('#home_fbox .bold-ro__frequency-type-text').removeAttr('name');
$('#home_fbox .bold-ro__group-id').removeAttr('name');
$('#home_fbox.bold-ro__discounted-price').removeAttr('name');
$('#home_fbox.bold-ro__discount-percentage').removeAttr('name');
$('#home_fbox.bold-ro__unformatted-price').removeAttr('name');
});

$( "#home_fbox .bold-ro__recurring-div .bold-ro__recurring-lbl" ).click(function() {
  $('#home_fbox .slide_product_pp .bold-ro__order-interval-container').show();
  $('#home_fbox .bold-ro__subscribe-radio-btn').prop("checked",true);
$('#home_fbox .bold-ro__one-time-radio-btn').removeAttr('checked');
$('#home_fbox .bold-ro__recurring-div').addClass('bold-ro__bold-active');
$('#home_fbox .bold-ro__one-time-div').removeClass('bold-ro__bold-active');
$('#home_fbox .bold-ro__frequency-type-text').attr('name','properties[frequency_type_text]');
$('#home_fbox .bold-ro__group-id').attr('name','properties[group_id]');
$('#home_fbox.bold-ro__discounted-price').attr('name','properties[discounted_price]');
$('#home_fbox.bold-ro__discount-percentage').attr('name','properties[_ro_discount_percentage]');
$('#home_fbox.bold-ro__unformatted-price').attr('name','properties[_ro_unformatted_price]');
});
  
  
  $('#home_fbox .bold-ro__subscribe-radio-btn').prop("checked",true);  
  
  
 
    $( ".item_slide_pp_1 #product-select" ).change(function() {      
      var dataprice= $( ".item_slide_pp_1 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );      
      $('.item_slide_pp_1 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_2 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_2 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_2 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_3 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_3 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_3 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_4 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_4 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_4 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_5 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_5 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_5 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_6 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_6 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_6 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_7 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_7 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_7 .home_prod_price').html(dataprice);
    });
     $( ".item_slide_pp_8 #product-select" ).change(function() {
      var dataprice= $( ".item_slide_pp_8 #product-select option:selected" ).attr('data-price');
      //alert( dataprice );
      $('.item_slide_pp_8 .home_prod_price').html(dataprice);
    });
     
  
  

  
  $("#col-main").after("<div id=buy-online class=text-center><a href=/collections/shop class=btn-red>buy online</a></div>");
  
  
  
  
  $('body.templateCustomersAddresses .action_top a').click(function() {
  $('#add_address').slideToggle();
});
  
  $('body.templateCustomersAddresses #add_address .note a').click(function() {
  $('#add_address').hide();
});
  
  $('body.templateCustomersAddresses .action_edit a').click(function() {
    var adr_edit_id= $('.action_edit').attr('id');
   $('#edit_address_' + adr_edit_id).slideToggle();
});
  
  $('body.templateCustomersAddresses .edit_address .note a').click(function() {
    var adr_edit_id= $(this).attr('id');
   $('#edit_address_' + adr_edit_id).hide();
});
  
  
  
  
  
  
  
  
  $('.collect_front_menu_nav a').click(function() {
      var dtype= $(this).attr('class');	 
      $('input[data-value='+ dtype +']').change(function(){
  if($(this).prop("checked")) {
    $('#filts label.'+ dtype).show();    
   
  } else {
    $('#filts label.'+ dtype).hide();
    
  }      
        
});
    
   
    
  if ($('.filters:has(:checkbox:checked)').length) {
    $('.product_filt_title_label').show();
  } else {  
     $('.product_filt_title_label').hide();
  }  
   
  
});
  
  
  
   $('#filts label .fa').click(function() {  
	  $(this).parents('label').hide();
});
  
  


   if (document.documentElement.clientWidth < 480) {
    $('#rel_prod_desk').addClass('mobslick');
}     
  
  $(document).ready(function(){$("img.lazyload").lazyload();});

  $('img').addClass('lazyload');
  
  // Subscription widget - Custom Plans Input
  $('.bsub-widget').each(function(){
  	$plansContainer = $(this).find('.bsub-widget__plans-container');
    
    $customPlansContainer = $('<div class="bsub-cp"></div>');
    $customPlansSelect = $('<select class="bsub-cp-select"></select>');
    $(this).find('.bsub-widget__plan').each(function(){
      var optionChecked = '';
      if($(this).find('input').prop('checked') != false){
       	optionChecked = 'selected="true"'; 
      }
      var optionValue = $(this).attr('data-bsub-selling-plan-id');
      var optionText = $(this).find('.bsub-widget__text').text();
      var optionPrice = $(this).find('.bsub-widget__plan-pricing [data-bsub-per-delivery-price]').text();
    	$customPlansSelect.append('<option class="bsub-cp-option" value="' + optionValue + '" ' + optionChecked + '>' + optionText + ' ' + optionPrice + '</select>');
    });
    
    $customPlansContainer.append($customPlansSelect);
    
    $plansContainer.append($customPlansContainer);
    
  });
  
  $(document).on('change','.bsub-cp-select',function(){
  	var planID = this.value;
    var $plansContainer = $(this).closest('.bsub-widget__plans-container');
    
    $plansContainer.find('input[value="' + planID + '"]').prop('checked',true).trigger('change');
  });
  
  // Subscription widget - Custom Plans Price Update
  $('body').on('DOMSubtreeModified', '.bsub-widget__plan', function(){
    var planID = $(this).attr('data-bsub-selling-plan-id');
    var optionPrice = $(this).find('[data-bsub-per-delivery-price]').text();
    var optionText = $(this).find('.bsub-widget__text').text();
    
    $(this).closest('.bsub-widget__plans-container').find('.bsub-cp-option[value="' + planID + '"]').text(optionText + ' ' + optionPrice);
  });
  
  //TODO: ON LOAD ACTIVE

  
});


$( document ).ready(function() {
   $('#home_fbox #slide_product_area_section #product-select option:first-child').attr('selected', 'selected'); 
});

$(document).on('change', '#home_fbox .item_slide_pp_1 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_1 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_1 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_1 #slide_product_area_section .home_prod_price').html(hrdprice);
        });

$(document).on('change', '#home_fbox .item_slide_pp_2 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_2 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_2 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_2 #slide_product_area_section .home_prod_price').html(hrdprice);
        });



$(document).on('change', '#home_fbox .item_slide_pp_3 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_3 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_3 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_3 #slide_product_area_section .home_prod_price').html(hrdprice);
        });


$(document).on('change', '#home_fbox .item_slide_pp_4 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_4 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_4 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_4 #slide_product_area_section .home_prod_price').html(hrdprice);
        });

$(document).on('change', '#home_fbox .item_slide_pp_5 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_5 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_5 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_5 #slide_product_area_section .home_prod_price').html(hrdprice);
        });


$(document).on('change', '#home_fbox .item_slide_pp_6 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_6 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_6 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_6 #slide_product_area_section .home_prod_price').html(hrdprice);
        });


$(document).on('change', '#home_fbox .item_slide_pp_7 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_7 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_7 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_7 #slide_product_area_section .home_prod_price').html(hrdprice);
        });


$(document).on('change', '#home_fbox .item_slide_pp_8 #slide_product_area_section #product-select', function () {
            var valuesel = $('#home_fbox .item_slide_pp_8 #slide_product_area_section #product-select').val();
            //$(this).find('option[value="' + value + '"]').attr("selected", "selected");
			//alert(valuesel);
            
			$('#home_fbox .item_slide_pp_8 #slide_product_area_section #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel + '"]').attr("selected", "selected");
  
            var hrdprice= $(this).find('option[value="' + valuesel + '"]').attr("data-price");
            $('#home_fbox .item_slide_pp_8 #slide_product_area_section .home_prod_price').html(hrdprice);
        });


$( document ).ready(function() {
   $('#collection_slide_pp_panel #product-select option:first-child').attr('selected', 'selected'); 
});


$(document).on('change', '.collection_slide_pp #product-select', function () {
            var valuesel2 = $('.collection_slide_pp #product-select').val();           
			$('.collection_slide_pp #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.green #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.green #product-select').val();           
			$('.collection_slide_pp.green #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.green .home_prod_price').html(hrdprice_coll);
  
        });

$(document).on('change', '.collection_slide_pp.violet #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.violet #product-select').val();           
			$('.collection_slide_pp.violet #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.violet .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.yellow #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.yellow #product-select').val();           
			$('.collection_slide_pp.yellow #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.yellow .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.pink #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.pink #product-select').val();           
			$('.collection_slide_pp.pink #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.pink .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.blue #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.blue #product-select').val();           
			$('.collection_slide_pp.blue #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.blue .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.cyan #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.cyan #product-select').val();           
			$('.collection_slide_pp.cyan #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.cyan .home_prod_price').html(hrdprice_coll);
        });

$(document).on('change', '.collection_slide_pp.red #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.red #product-select').val();           
			$('.collection_slide_pp.red #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.red .home_prod_price').html(hrdprice_coll);
        });


$(document).on('change', '.collection_slide_pp.orange #product-select', function () {
            var valuesel2 = $('.collection_slide_pp.orange #product-select').val();           
			$('.collection_slide_pp.orange #product-select option').removeAttr("selected", "selected");
			$(this).find('option[value="' + valuesel2 + '"]').attr("selected", "selected");
  
            var hrdprice_coll= $(this).find('option[value="' + valuesel2 + '"]').attr("data-price");
            $('.collection_slide_pp.orange .home_prod_price').html(hrdprice_coll);
        });



